import { Dispatch, SetStateAction } from 'react';
import { Level } from '../interfaces';
import { API } from '../data/30pay.api';
import { get } from '../scripts';

export const _getLevel = async (
    setLoading: Dispatch<SetStateAction<boolean>>,
    setData: Dispatch<SetStateAction<Level | undefined>>
) => {
    setLoading(true);
    await get<Level>(API.level.mine).then((response) => {
        setLoading(false)
        setData(response.value.value)
    })
}